import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Dropdown } from 'react-bootstrap';

// utils
import { handleCatchError } from 'utils/handleErrors';
// api
import { getBillingDocs } from '../../../../../api/Api-admin';

// components
import Paginate from '../../../../../components/Paginate';
import BillingRow from '../components/BillingRow';
import BillingCard from '../components/BillingCard';
import LoadingPulse from '../../../../../../components/loading/LoadingPulse';

function Receipts({ crmId }) {
  const [receipts, setReceipts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // paginate
  const [totalPages, setTotalPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [message, setMessage] = useState('');

  // - Use references to do scroll Up
  const startRef = useRef(null);

  useEffect(() => {
    const handlerGetReceipts = () => {
      setIsLoading(true);
      getBillingDocs('receipts', crmId, currentPage, pageSize)
        .then((response) => {
          // console.log('Get receipts res -->', response);
          if (response.data !== undefined) {
            setIsLoading(false);
            setReceipts(response.data);
            setTotalPages(response.total_pages);
            if (response?.data.length === 0) {
              setMessage('No hay recibos registrados.');
            }
            if (startRef.current) {
              startRef.current.scrollIntoView({ behavior: 'smooth' });
            }
          }
        })
        .catch((error) => {
          handleCatchError(error);
          setIsLoading(false);
          setMessage('Error');
          // console.log('Err catch get receips',err)
        });
    };
    handlerGetReceipts();
  }, [currentPage, pageSize]);
  // console.log('Get receipts res -->', receipts)

  const settingPage = (limit) => {
    setIsLoading(true);
    setPageSize(limit);
    setCurrentPage(1);
  };
  return (
    <>
      {isLoading && <LoadingPulse />}
      {message ? (
        <div className="pt-5 mt-5">
          <h3 className="text-center mt-5 pt-5">
            {message}
            <img alt="box" src="/img/animation/doc.webp" style={{ width: '50px', height: '50px' }} />{' '}
          </h3>
        </div>
      ) : (
        <div ref={startRef} id="cardContainer">
          <Row>
            <Col className="mb-1 text-end">
              {/* {receipts?.length > 0 && <ReceiptsCSV receipts={receipts} />} */}
              <Dropdown align={{ xs: 'end' }} className={`d-inline-block ms-1 ${receipts?.length < 10 && 'invisible'}`}>
                <Dropdown.Toggle variant="foreground-alternate" className="shadow sw-15">
                  {`${pageSize} Recibos`}
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow dropdown-menu-end">
                  <Dropdown.Item className={`${pageSize === 10 && 'd-none'}`} onClick={() => settingPage(10)}>
                    10 Recibos
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 20 && 'd-none'}`} onClick={() => settingPage(20)}>
                    20 Recibos
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 50 && 'd-none'}`} onClick={() => settingPage(50)}>
                    50 Recibos
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 100 && 'd-none'}`} onClick={() => settingPage(100)}>
                    100 Recibos
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div className={`text-muted d-lg-none mt-3 ${receipts?.length < 2 && 'invisible'}`}>{`Página ${currentPage}`}</div>
              {/* Length End */}
            </Col>
          </Row>
          <Row className="g-0 mb-2 d-none d-lg-flex">
            <Col xs="auto" className={`text-muted mb-3 ${receipts?.length < 2 && 'invisible'}`}>
              {`Página ${currentPage}`}
            </Col>
          </Row>
          <BillingRow />
          {/* List Header End */}
          {/* List Items Start */}
          {receipts?.map((receipt, index) => (
            <BillingCard data={receipt} key={index} crmId={crmId} doc="receipt" />
          ))}

          {/* List Items End */}
          {/* Pagination Start */}
          <div className={`d-flex flex-column justify-content-center align-items-center mt-5 mx-auto ${totalPages < 2 && 'd-none'}`}>
            <Paginate currentPage={currentPage} totalPages={totalPages} setCurrentPage={setCurrentPage} />
          </div>
          {/* Pagination End */}
        </div>
      )}
    </>
  );
}

export default Receipts;
